export const billingFallbacks: Record<string, Record<string, string>> = {
  fr: {
    // ─── Document Titles & Vertical Badges ──────────────────────────────
    'CLINICAL OUTPATIENT BILL': 'FACTURE CLINIQUE AMBULATOIRE',
    'OFFICIAL CLINICAL INVOICE & MEDICAL BILL': 'FACTURE MÉDICALE & CLINIQUE OFFICIELLE',
    'OFFICIAL MEDICAL INVOICE & CLINICAL BILL': 'FACTURE MÉDICALE ET DÉCOMPTE CLINIQUE OFFICIEL',
    'Patient Episode & Encounter Financial Settlement': 'Règlement Financier des Soins et Hospitalisation du Patient',
    'Official Hospital Medical Bill & Invoice': 'Facture Médicale & Reçu Officiel Hospitalier',
    'Accredited Institutional Billing Document': 'Document de Facturation Institutionnel Agréé',
    'Print Official Bill (A4)': 'Imprimer Facture Officielle (A4)',
    'PDF Invoice': 'Facture PDF',
    'PDF Receipt': 'Reçu PDF',
    'RESTAURANT GUEST BILL & RECEIPT': 'ADDITION & REÇU RESTAURANT',
    'TABLE ORDER BILL': 'ADDITION COMMANDE DE TABLE',
    'PHARMACY DISPENSING RECEIPT': 'TICKET DE DÉLIVRANCE PHARMACIE',
    'RX MEDICATION RECEIPT': 'REÇU MÉDICAMENT SUR ORDONNANCE',
    'SUPERMARKET ITEM RELEVE': 'RELEVÉ D\'ARTICLES SUPERMARCHÉ',
    'STORE RECEIPT': 'REÇU DE MAGASIN',
    'BOUTIQUE FASHION SALE': 'FACTURE VENTE PRÊT-À-PORTER',
    'SALES SLIP': 'BORDEREAU DE VENTE',
    'HARDWARE & BUILDING MATERIALS': 'MATÉRIAUX DE CONSTRUCTION & QUINCAILLERIE',
    'SUPPLY RECEIPT': 'BORDEREAU DE FOURNITURE',
    'OFFICIAL SALES RECEIPT': 'REÇU OFFICIEL DE VENTE',
    'SALES RECEIPT': 'TICKET DE CAISSE',
    'HOTEL GUEST FOLIO & STATEMENT': 'NOTE DE SÉJOUR & FACTURE HÔTEL',
    'ROOM FOLIO & BILL': 'FACTURE SÉJOUR CHAMBRE',
    'BAR & DRINKS TAB RECEIPT': 'ADDITION BAR & BOISSONS',
    'BAR TAB RECEIPT': 'ADDITION BAR',
    'Receipt': 'Reçu',
    'Receipt_Reprint': 'Reimpression_Recu',
    'Invoice & Receipt Statement': 'Relevé de facture et reçu',
    'Official billing statement details': 'Détails du relevé de facturation officiel',
    'Official Medical Bill': 'Facture Médicale Officielle',
    'Patient Inpatient Statement': 'Relevé d\'Hospitalisation du Patient',
    'Print Ward Bill': 'Imprimer la Facture d\'Hospitalisation',
    'Clinical Case Sheet Summary': 'Résumé du Dossier Clinique',
    'Inpatient Admission Register Record': 'Registre d\'Admission d\'Hospitalisation',
    'Invoice & Patient Ledger Statement': 'Relevé de Facturation & Compte Patient',
    'Laboratory Diagnostic Report': 'Rapport de Diagnostic de Laboratoire',

    // ─── Headers, Meta & Identification ─────────────────────────────────
    'Invoice No': 'N° DE FACTURE',
    'Invoice #': 'Facture N°',
    'Bill #': 'Facture N°',
    'Order ID': 'N° Commande',
    'Transaction ID': 'N° Transaction',
    'Total Bill': 'MONTANT TOTAL',
    'Gross Total': 'Total Brut',
    'Gross Total Charges': 'Total Général Facturé',
    'Gross Clinical Total:': 'Total Clinique Brut :',
    'Patient / Client': 'PATIENT / CLIENT',
    'Walking Customer': 'Client de Passage',
    'Walking Outpatient': 'Patient Ambulatoire',
    'PATIENT:': 'PATIENT :',
    'MRN:': 'DOSSIER MÉDICAL :',
    'MRN / ID:': 'Dossier Médical (MRN) :',
    'MRN / ID': 'Dossier Médical (MRN)',
    'PATIENT CLINICAL IDENTIFICATION': 'IDENTIFICATION CLINIQUE DU PATIENT',
    'Patient Details': 'Détails du Patient',
    'Location Details': 'Localisation / Salle',
    'Record No': 'Dossier N°',
    'Bed Number': 'Numéro de Lit',
    'Allocated Bed': 'Lit Attribué',
    'Admitting Ward': 'Service d\'Admission',
    'Admitting Diagnosis': 'Diagnostic d\'Admission',
    'Attending Consultant': 'Médecin Traitant',
    'Attending Physician': 'Médecin Traitant',
    'ATTENDING PHYSICIAN:': 'MÉDECIN TRAITANT :',
    'DOCTOR:': 'MÉDECIN :',
    'Doctor': 'Médecin',
    'Physician': 'Médecin Traitant',
    'Ordering Physician': 'Médecin Prescripteur',
    'Ordered By': 'Prescrit par',
    'Ordered By:': 'Prescrit par :',
    'Test Requested': 'Examen Demandé',
    'Test Request': 'Demande d\'Examen',
    'Test Request:': 'Demande d\'Examen :',
    'Date Admitted': 'Date d\'Admission',
    'Admission Date': 'Date d\'Admission',
    'Discharge Date': 'Date de Sortie',
    'Amount Billed': 'Montant Facturé',
    'Ward Clinical Observation Notes': 'Observations Cliniques en Salle',
    'Ward Clinical Observation Notes:': 'Observations Cliniques en Salle :',
    'Diagnostic Laboratory Results': 'Résultats de Diagnostic de Laboratoire',
    'Diagnostic Lab Results': 'Résultats d\'Analyses Médicales',
    'Parameter': 'Paramètre',
    'PARAMETER': 'PARAMÈTRE',
    'Result Value': 'Résultat',
    'RÉSULTAT': 'RÉSULTAT',
    'Reference Range': 'Valeur de Référence',
    'INTERVALLE DE RÉFÉRENCE': 'INTERVALLE DE RÉFÉRENCE',
    'Alert Flag': 'Alerte / Statut',
    'ALERT FLAG': 'ALERTE',
    'NORMAL': 'NORMAL',
    'CRITICAL': 'CRITIQUE',
    'HIGH': 'ÉLEVÉ',
    'LOW': 'BAS',
    'Result parameters pending confirmation.': 'Paramètres des résultats en attente de validation.',
    'Lab Technician:': 'Technicien de Laboratoire :',
    'Authorized Signatory:': 'Signataire Autorisé :',
    'Specimen Collected:': 'Prélèvement Analysé :',
    'Report Date:': 'Date du Rapport :',
    'Department of Clinical Services & Billing': 'Département des Soins Cliniques & Facturation',
    'GENDER': 'SEXE',
    'Gender': 'Sexe',
    'Male': 'Homme',
    'Female': 'Femme',
    'AGE': 'ÂGE',
    'Age': 'Âge',
    'yrs': 'ans',
    'CONTACT': 'CONTACT',
    'Contact': 'Contact',
    'STAFF': 'Personnel',
    'STAFF: ': 'Personnel : ',
    'Cashier': 'Caissier',
    'Cashier / Billing': 'Caissier / Facturation',
    'Hospital Cashier / Billing': 'Caissier / Facturation Hospitalière',
    'Authorized Cashier': 'Caissier Agréé',
    'Medical Superintendent': 'Médecin Directeur',
    'Dr. Medical Superintendent': 'Dr. Médecin Directeur',
    'Clinical Administration': 'Direction Médicale & Clinique',
    'Unknown Ward': 'Salle Inconnue',

    // ─── Insurance & Financial Payer ────────────────────────────────────
    'INSURANCE & BILLING METADATA': 'DONNÉES D\'ASSURANCE & FACTURATION',
    'Primary Payer': 'Organisme Payeur Principal',
    'Primary Payer:': 'Organisme Payeur Principal :',
    'PAYER:': 'PAYEUR :',
    'Private / Self-Pay': 'Privé / Auto-Payant',
    'Policy / Card #': 'Police / Carte N°',
    'POLICY #:': 'POLICE N° :',
    'Insurance Coverage': 'Prise en Charge Assurance',
    'Insurance Payer Share': 'Part Prise en Charge Assurance',
    'Insurance Payer Share:': 'Part Prise en Charge Assurance :',
    'Insurance Share (85%):': 'Part Assurance (85%) :',
    'Patient Co-Pay Share': 'Part Ticket Modérateur (Patient)',
    'Patient Co-Pay Share:': 'Part Ticket Modérateur (Patient) :',
    'Patient Co-Pay (15%):': 'Ticket Modérateur Patient (15%) :',
    'Amount Payable (Copay)': 'Montant à Payer (Ticket Modérateur)',
    'Amount Payable (Copay):': 'Montant à Payer (Ticket Modérateur) :',
    'Date of Service': 'Date de Prestation',
    'Date of Service:': 'Date de Prestation :',
    'Payment Channel': 'Moyen de Paiement',
    'Payment Channel:': 'Moyen de Paiement :',
    'Department': 'Service / Département',
    'Department:': 'Service / Département :',
    'Clinical Consultations & Services': 'Consultations & Soins Cliniques',
    'OUTPATIENT CLINICAL SERVICE': 'SERVICE CLINIQUE AMBULATOIRE',
    'Clinical Consultation & Medical Evaluation': 'Consultation Clinique & Évaluation Médicale',
    'General Medical Services Fee': 'Frais Généraux de Soins Médicaux',
    'Admission Fee': 'Frais d\'Admission en Salle',
    'Bed Charges': 'Frais d\'Hébergement / Lit',

    // ─── Line Items & Table Headers ─────────────────────────────────────
    'Product name': 'Nom du produit',
    'Service / Item Description': 'Description de l\'Acte / Prestation',
    'Billed Item / Service': 'Prestation / Acte Médical Facturé',
    'Itemized Clinical Services & Medical Charges': 'Détail des Actes Cliniques et Frais Médicaux',
    'Itemized Charges Breakdown': 'Détail des Frais Facturés',
    'Quantity': 'Quantité',
    'Qty': 'Qté',
    'Quantity / Duration': 'Quantité / Durée',
    'Rate': 'Tarif',
    'Unit Price': 'Prix Unitaire',
    'Unit Price (RWF)': 'Prix Unitaire (RWF)',
    'Unit Price (CDF)': 'Prix Unitaire (CDF)',
    'Price': 'Prix',
    'Total Price': 'Prix Total',
    'Line Total': 'Total Ligne',
    'Line Total (RWF)': 'Total Ligne (RWF)',
    'Line Total (CDF)': 'Total Ligne (CDF)',
    'Description': 'Description',
    'Amount': 'Montant',
    'Amount:': 'Montant :',

    // ─── Summary, Payments & Totals ─────────────────────────────────────
    'Statement Summary': 'Résumé du relevé',
    'Subtotal': 'Sous-Total',
    'Subtotal:': 'Sous-Total :',
    'Subtotal amount': 'Montant Sous-Total',
    'Subtotal amount:': 'Montant Sous-Total :',
    'Loan': 'Crédit / Dette',
    'Discount': 'Remise',
    'Waiter Tip': 'Pourboire Serveur',
    'TOTAL': 'TOTAL',
    'TOTAL:': 'TOTAL :',
    'Total': 'Total',
    'Paid': 'Payé',
    'Amount Paid': 'Montant Payé',
    'Amount Paid:': 'Montant Payé :',
    'Amount Paid to Date': 'Montant Déjà Réglé',
    'Amount Paid to Date:': 'Montant Déjà Réglé :',
    'Change': 'Monnaie Rendue',
    'Remaining Balance': 'Solde Restant',
    'Remaining Balance:': 'Solde Restant :',
    'Total Balance Due': 'Solde Restant Dû',
    'Balance Due': 'Solde Dû',
    'BALANCE DUE': 'RESTE À PAYER',
    'Bill Fully Settled': 'Facture Entièrement Soldée',
    'SETTLED / PAID': 'RÉGLÉ / PAYÉ',
    'PAID': 'PAYÉ',
    'Paid Via': 'Payé par',
    'Payment Method': 'Mode de Paiement',
    'Payment Method:': 'Mode de Paiement :',
    'PARTIAL': 'PARTIEL',
    'PENDING': 'EN ATTENTE',
    'Cash': 'Espèces',
    'MOMO': 'Mobile Money',
    'Credit': 'Crédit',
    'Card': 'Carte Bancaire',
    'Bank Transfer': 'Virement Bancaire',
    'Cash / MoMo': 'Espèces / Mobile Money',
    'Cashier & Billing Desk': 'Guichet de Caisse & Facturation',

    // ─── Official Stamp & Credentials ───────────────────────────────────
    '★ OFFICIAL CLINICAL STAMP ★': '★ CACHET CLINIQUE OFFICIEL ★',
    '★ OFFICIAL STAMP ★': '★ CACHET OFFICIEL ★',
    'VERIFIED & CERTIFIED': 'VÉRIFIÉ & CERTIFIÉ CONFORME',
    'VERIFIED': 'VÉRIFIÉ',
    'VERIFIED:': 'VÉRIFIÉ :',
    'SETTLEMENT / PAYMENT': 'RÈGLEMENT & PAIEMENT',
    'Official Hospital Remittance Instructions': 'Instructions Officielles de Règlement Hospitalier',
    'MOH LIC:': 'Licence MinSanté :',
    'TAX ID (TIN):': 'NIF Fiscal :',
    'PHONE:': 'TÉL :',
    'TEL: ': 'Tél : ',
    'WEB:': 'SITE WEB :',
    'LIC:': 'Licence :',
    'TIN:': 'NIF :',
    '24/7 EMERGENCY & AMBULANCE': 'URGENCES 24/7 & AMBULANCE',
    '🚨 24/7 EMERGENCY & AMBULANCE': '🚨 URGENCES 24/7 & AMBULANCE',
    '🚨 24/7 HOTLINE:': '🚨 LIGNE D\'URGENCE 24/7 :',
    '🚨 24/7 EMERGENCY:': '🚨 URGENCES 24/7 :',

    // ─── Footers & Disclaimers ──────────────────────────────────────────
    'SCAN TO DOWNLOAD': 'SCANNER POUR TÉLÉCHARGER',
    'Thank you!': 'Merci de votre visite !',
    'POWERED BY': 'PROPULSÉ PAR',
    'Pickup Code': 'Code de Retrait',
    'Show this code at the store for delivery': 'Présentez ce code en magasin pour le retrait',
    'Official Medical Bill. Thank you for entrusting us with your health and care.':
      'Facture Médicale Officielle. Merci de nous confier votre santé et vos soins.',
    'Keep this slip for insurance claims and follow-up consultation.':
      'Conservez ce reçu pour les remboursements d\'assurance et consultations de suivi.',
    'Thank you for dining with us! Service included.':
      'Merci d\'avoir déjeuné chez nous ! Service compris.',
    'Please present this slip to the server for table payment settlement.':
      'Veuillez présenter cette addition au serveur pour le règlement de votre table.',
    'Please take medications as directed by your physician or pharmacist.':
      'Veuillez prendre vos médicaments selon les indications de votre médecin ou pharmacien.',
    'Retain this dispensing slip for health insurance claims and refills.':
      'Conservez ce volet de dispensation pour vos remboursements d\'assurance et renouvellements.',
    'Goods once sold in good condition are not returnable without original receipt.':
      'Les marchandises vendues ne sont ni reprises ni échangées sans présentation du ticket original.',
    'Please verify your change and items before leaving the checkout counter.':
      'Veuillez vérifier votre monnaie et vos articles avant de quitter la caisse.',
    'Returns & exchanges accepted within 7 days with original tags attached.':
      'Échanges et retours acceptés sous 7 jours avec étiquette d\'origine.',
    'Keep this slip as your proof of purchase for size exchange.':
      'Conservez ce bordereau comme preuve d\'achat pour tout échange de taille.',
    'Please inspect materials upon delivery. Breakage must be noted on waybill.':
      'Veuillez vérifier les matériaux dès livraison. Tout dommage doit être noté sur le bordereau.',
    'Delivery fees and offloading are subject to separate transport arrangements.':
      'Les frais de livraison et de déchargement font l\'objet d\'accords de transport séparés.',
    'Thank you for your business! Please visit us again.':
      'Merci pour votre confiance ! Au plaisir de vous revoir.',
    'Valid official customer copy for personal and commercial records.':
      'Copie client officielle valable pour archives personnelles et professionnelles.',
    'HIMS Computer Generated Document • Certified & Authenticated by Hospital Billing Administration • Printed on':
      'Document Informatisé HIMS • Certifié et Authentifié par l\'Administration Hospitalière • Imprimé le',
    'FUKO HOSPITAL HIMS': 'FUKO HIMS HOSPITALIER',

    // ─── Actions ────────────────────────────────────────────────────────
    'Print Sheet': 'Imprimer la Fiche',
    'Thermal Print': 'Impression thermique',
    'Save as PDF': 'Enregistrer en PDF',
    'Record Payment': 'Enregistrer un Paiement',
    'Close': 'Fermer',
    'Settle Payment': 'Régler le Paiement',
    'Payment Amount': 'Montant du Paiement',
    'Notes / Reference': 'Notes / Référence',
  },
};
